module.exports = __webpack_public_path__ + "img/exit-btn.1ebc4f13.svg";